export const UPDATE_SCREEN = 'SCREEN/UPDATE_SCREEN';
export const CLEAR_SCREEN = 'SCREEN/CLEAR_SCREEN';
